module.exports = __webpack_public_path__ + "static/thehub-88d672405e5852d926baa2081ed691f9.jpg";